var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"container"},[(_vm.title)?_c('h3',{staticClass:"container__title",class:_vm.classes.title},[_vm._v("\n    "+_vm._s(_vm.title)+"\n  ")]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"container__content"},[_c('render-content',{attrs:{"content":_vm.components}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }